export const setCssValueUnity = (value: number | string | undefined) => {
  if (!value) return undefined
  return typeof value === 'number' ? `${value}px` : value
}
